import Reflux from "reflux";
import { ActionsTempDraftCreation } from "../Actions/ActionsTempDraftCreation/ActionsTempDraftCreation";

export default class TempDraftCreationStore extends Reflux.Store {
  constructor() {
    super();

    this.state = {
      tempDraftCampaignId: ""
    };

    this.listenables = ActionsTempDraftCreation;
  }

  onChangeTempDraftCampaignId(draftId) {
    this.setState({ tempDraftCampaignId: draftId });
  }
}
